module.exports = __webpack_public_path__ + "img/Shape.ab28ef24.svg";